import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { UIStatusChip } from "../../../../components/ui";
import {
  buildReportSummaryCardSx,
  reportSummaryCardContentSx,
  reportSummaryHeaderSx,
  reportSummaryHelperTextSx,
  reportSummaryLabelSx,
  reportSummaryStatusSx,
  reportSummaryValueSx,
} from "./reportLayout";

const normalizeStatus = (status) => {
  if (!status) return null;
  if (typeof status === "string") return { label: status, tone: "neutral" };
  if (typeof status === "object" && status.label) {
    return {
      label: status.label,
      tone: status.tone || "neutral",
    };
  }
  return null;
};

const ReportSummaryCard = ({ label, value, tone = "default", helperText = "", status = null, sx = {} }) => {
  const normalizedStatus = normalizeStatus(status);
  const renderValueAsNode = React.isValidElement(value);

  return (
    <Paper elevation={0} sx={{ ...buildReportSummaryCardSx(tone), ...sx }}>
      <Box sx={reportSummaryCardContentSx}>
        <Box sx={reportSummaryHeaderSx}>
          <Typography variant="caption" sx={reportSummaryLabelSx}>
            {label}
          </Typography>
          {normalizedStatus ? (
            <Box sx={reportSummaryStatusSx}>
              <UIStatusChip label={normalizedStatus.label} tone={normalizedStatus.tone} />
            </Box>
          ) : null}
        </Box>

        {renderValueAsNode ? (
          <Box sx={reportSummaryValueSx(tone)}>
            {value}
          </Box>
        ) : (
          <Typography variant="h6" sx={reportSummaryValueSx(tone)}>
            {value}
          </Typography>
        )}

        {helperText ? (
          <Typography variant="caption" sx={reportSummaryHelperTextSx}>
            {helperText}
          </Typography>
        ) : null}
      </Box>
    </Paper>
  );
};

export default ReportSummaryCard;
